import { createAction, createAsyncAction } from '@/redux/root';

export const nameSpace = '@@/aspyn-migrator';

export const pushToAspynAsync = createAsyncAction(`${nameSpace}/PUSH_TO_ASPYN`);

export const clearAspynResultAction = createAction(`${nameSpace}/CLEAR_ASPYN_RESULT`);

export const seedPrerequisiteEntitiesAsync = createAsyncAction(`${nameSpace}/SEED_PREREQUISITE_ENTITIES`);

export const clearCacheOfAspynPushesAsync = createAsyncAction(`${nameSpace}/CLEAR_CACHE_OF_ASPYN_PUSHES`);

export const requestMigrationJobsAsync = createAsyncAction(`${nameSpace}/REQUEST_MIGRATION_JOBS`);

export const migrateRepsAsync = createAsyncAction(`${nameSpace}/MIGRATE_REPS`);

export const migrateHousingAsync = createAsyncAction(`${nameSpace}/MIGRATE_HOUSING`);
